import { Pagination } from "antd";

import classes from "../Tables/Table.module.css";

interface props {
  onShowSizeChange: (current: number, size: number) => void;
  total: number;
  current: number;
  onChange: (e: number, size: number) => void;
  PageSizeOptions?: number[];
  defaultPageSize?: number;
  style?: any;
  showSizeChanger?: boolean;
  pageSize?: number;
}

function Commonpagination({
  onShowSizeChange,
  total,
  current,
  onChange,
  PageSizeOptions,
  defaultPageSize,
  style,
  showSizeChanger = true,
  pageSize
}: // pageSize,
props) {
  return (
    <>
      {total ? (
        <div
          className={classes.paginateContainer}
          id="pagination"
          style={style}
        >
          <Pagination
            responsive
            onShowSizeChange={onShowSizeChange}
            total={total}
            current={current}
            onChange={onChange}
            pageSizeOptions={PageSizeOptions}
            defaultPageSize={defaultPageSize}
            showSizeChanger={showSizeChanger}
            pageSize={pageSize}
          />
        </div>
      ) : null}
    </>
  );
}

export default Commonpagination;
